// extracted by mini-css-extract-plugin
module.exports = {"figure":"Blockquote_figure__r_gkP"};